import payment from '@js/store/modules/payment';
import { mapActions } from 'vuex';

export default {
    data() {
        let that = this;

        return {
            preSelectOperator: true,

            returnOperatorValueList: true,

            externalRemotes: {
                payment(query) {
                    return that
                        .getPaymentListIfNecessary({ query })
                        .then(data => {
                            return data.map(d => ({
                                id: d.id,
                                display_name: d.name,
                            }));
                        });
                },
            },
        };
    },

    created() {
        if (!this.$store.hasModule('payment')) {
            this.$store.registerModule('payment', payment);
        }
    },

    methods: {
        ...mapActions('payment', ['getPaymentListIfNecessary']),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/payment-filter/payment-filter-mixin.js